/**
 * Minimal template thumbnail page — no auth, no API, no Firestore.
 * Used only for inline iframe previews in the Marketplace card grid.
 * Renders the template directly from local preset data with mock device data.
 */
import { lazy, Suspense } from 'react'
import type { ComponentType } from 'react'
import { useParams } from 'react-router-dom'
import { getTemplatePreset } from '../../ultron-turing-manager/src/data/appsuite-template-presets'
import { SmartHomeDashboardTemplate, type SmartHomeDashboardTemplateProps } from '../../ultron-turing-manager/src/pages/appfactory/templates/SmartHomeDashboardTemplate'
import './AppSuiteTemplateThumbnailPage.css'

const EnvironmentalComfortTemplate = lazy(() =>
  import('../../ultron-turing-manager/src/pages/appfactory/templates/EnvironmentalComfortTemplate').then((m) => ({
    default: m.EnvironmentalComfortTemplate,
  }))
)
const AcuoAppV1Template = lazy(() =>
  import('../../ultron-turing-manager/src/pages/appfactory/templates/AcuoAppV1Template').then((m) => ({
    default: m.AcuoAppV1Template,
  }))
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TEMPLATE_COMPONENTS: Record<string, ComponentType<any>> = {
  'smart-home-dashboard-v1': SmartHomeDashboardTemplate,
  'smart-home-v1': SmartHomeDashboardTemplate,
  'environmental-comfort-v1': EnvironmentalComfortTemplate,
  'acuo-app-v1': AcuoAppV1Template,
  'acuo-v1': AcuoAppV1Template,
}

export default function AppSuiteTemplateThumbnailPage() {
  const { templateId } = useParams<{ templateId: string }>()
  const preset = templateId ? getTemplatePreset(templateId) : null
  const TemplateComponent = templateId ? TEMPLATE_COMPONENTS[templateId] : null

  if (!preset || !TemplateComponent) {
    return (
      <div className="tmpl-thumbnail-outer">
        <div style={{ color: '#ef4444', fontSize: 14 }}>Unknown template</div>
      </div>
    )
  }

  return (
    <div className="tmpl-thumbnail-outer">
      <div className="tmpl-thumbnail-frame">
        <Suspense fallback={null}>
          <TemplateComponent
            sections={preset.sections as SmartHomeDashboardTemplateProps['sections']}
            tokens={preset.styles?.tokens as SmartHomeDashboardTemplateProps['tokens']}
            isAppFactoryPreview
            forceMockData
          />
        </Suspense>
      </div>
    </div>
  )
}
